import $ from "jquery";

class Title {
    constructor(element) {
        this.$title = $(element);
        this.titleEl = `#${this.$title.attr("id")}`;
        this.sentence = this.$title.text();
        const deleteChars = Number.parseInt(this.$title.attr("data-animation-delete"), 10);
        this.deleteChars = Number.isFinite(deleteChars) ? Math.max(0, deleteChars) : 0;
        this.animatedText = this.$title.attr("data-animation-text") || "";
        this.accessibleText = this.$title.siblings(".el-h__title--accessible").text();
        this.typeItElement = null;

        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !window.TypeIt) {
            this.$title.text(this.accessibleText || this.sentence);
            return;
        }

        if (!this.sentence || !this.animatedText) return;

        $(this.start.bind(this));
        $(window).on("resize", this.debounce(() => {
            this.typeItElement?.destroy();
            this.$title.text(this.sentence).css("height", "");
            this.start();
        }, 1500));
    }

    debounce(callback, delay) {
        let timeout;
        return () => {
            clearTimeout(timeout);
            timeout = setTimeout(callback, delay);
        };
    }

    start() {
        const $title = this.$title;
        $title.css("height", $title.outerHeight()).text("");
        let animation = new window.TypeIt(this.titleEl, {
            speed: 100,
            deleteSpeed: 100,
            waitUntilVisible: true,
        })
            .type(this.sentence, {delay: 100})
            .pause(1000);

        if (this.deleteChars > 0) {
            animation = animation.delete(this.deleteChars, {delay: 1000});
        }

        this.typeItElement = animation
            .pause(200)
            .type(this.animatedText)
            .go();
    }
}

// Recreates the legacy stacked-header behaviour: when the next elemental
// header reaches the viewport top, its predecessor is replaced by a clone and
// moves out of view instead of remaining underneath it.
class ElementHeader {
    constructor() {
        this.minWindowWidth = 750;
        this.headers = $(".main .el-header");
        this.headerAnimation = false;
        this.scrollDetection = null;
        this.headerClones = $();

        if (!this.headers.length) return;

        this.roundHeader();
        this.checkHeaderAnimation(false);

        let previousScrollPosition = document.body.getBoundingClientRect().top;
        $(window).on("scroll", () => {
            const currentScrollPosition = document.body.getBoundingClientRect().top;
            this.scrollDetection = currentScrollPosition > previousScrollPosition ? "up" : "down";
            previousScrollPosition = currentScrollPosition;

            if (currentScrollPosition === 0) this.headers.first().css("opacity", 1);
            this.checkPosition();
            this.changeHamburgerColor();
        });

        let resizeTimer;
        $(window).on("resize", () => {
            $(".typo-header").css("height", "");
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                this.roundHeader();
                this.checkHeaderAnimation();
            }, 250);
        });
    }

    roundHeader() {
        const height = Math.round($(".typo-header").first().innerHeight());
        if (height) $(".typo-header").css("height", height);
    }

    checkHeaderAnimation(checkPosition = true) {
        this.headerHeight = this.headers.first().outerHeight(true);
        this.resetClones();
        this.headerAnimation = $(window).width() >= this.minWindowWidth;
        this.cloneHeaders();
        if (checkPosition) this.checkPosition();
    }

    resetClones() {
        $(".el-header.clone").remove();
        this.headerClones = $();
    }

    offset(element) {
        const rectangle = element.getBoundingClientRect();
        return {
            top: rectangle.top + (window.pageYOffset || document.documentElement.scrollTop),
            left: rectangle.left + (window.pageXOffset || document.documentElement.scrollLeft),
        };
    }

    cloneHeaders() {
        if (!this.headerAnimation || !this.headerHeight) return;

        const headerCount = this.headers.length;
        this.headers.each((index, element) => {
            if (index + 1 >= headerCount) return;

            const $clone = $(element).clone().appendTo("body");
            const id = $clone.attr("id");
            const nextHeader = this.headers.get(index + 1);
            const nextOffset = this.offset(nextHeader);

            $clone
                .removeClass("sticky active")
                .attr("id", `${id}__clone`)
                .css({height: this.headerHeight, opacity: 0, top: nextOffset.top - this.headerHeight})
                .attr("data-top", nextOffset.top)
                .attr("data-headerheight", this.headerHeight)
                .addClass("clone");
        });

        this.headerClones = $(".el-header.clone");
    }

    setCurrent($current, $previous) {
        $current.addClass("flip active");
        $previous?.removeClass("active");
    }

    changeHamburgerColor() {
        const $header = $(".header");
        $(".el-header.bg-black:not('.clone')").each((_, element) => {
            const $element = $(element);
            const top = element.getBoundingClientRect().top;
            if (top === 0 && $element.css("opacity") === "1") {
                $header.addClass("bg-white");
            } else if (top >= 1 || (top === 0 && $element.css("opacity") === "0")) {
                $header.removeClass("bg-white");
            }
        });
    }

    checkPosition() {
        if (!this.headerAnimation || !this.headerHeight || !this.scrollDetection) return;

        this.headers.each((index, element) => {
            const $current = $(element);
            const $previous = index >= 1 ? $(this.headers.get(index - 1)) : $();
            const $clone = index >= 1 ? $(this.headerClones.get(index - 1)) : $();
            const currentTop = element.getBoundingClientRect().top;

            if (this.scrollDetection === "down") {
                if (currentTop <= this.headerHeight && index >= 1) {
                    $current.addClass("sticky");
                    if ($clone.length) $clone.css("opacity", 1);
                    $previous.css("opacity", 0);
                }
                if (currentTop === 0) this.setCurrent($current, $previous);
                return;
            }

            if (index < 1 || !$clone.length) return;
            const cloneTop = $clone.get(0).getBoundingClientRect().top;
            $clone.css("opacity", 1);
            if (cloneTop >= 0) {
                $clone.css("opacity", 0);
                $current.removeClass("active flip");
                $previous.addClass("flip active").css("opacity", 1);
            }
            if (cloneTop > this.headerHeight) $clone.css("opacity", 0);
            if (currentTop > this.headerHeight) $current.css("opacity", 1);
        });
    }
}

class Navigation {
    constructor($menuToggle) {
        this.menuToggle = $menuToggle;
        this.body = $("body");
        this.navContainer = $(".menu-container");
        this.scrollLinks = $(".js-scroll");
        this.navFooter = $();

        this.setViewportHeight();
        $(window).on("resize", () => this.setViewportHeight());
        this.menuToggle.on("click tap", (event) => {
            this.navFooter = $(".nav__footer");
            this.body.hasClass("nav-open") ? this.closeNav() : this.openNav();
            event.preventDefault();
        });
        if (this.body.hasClass("page--home")) {
            this.scrollLinks.on("click tap", () => this.closeNav());
        }
    }

    setViewportHeight() {
        document.documentElement.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    }

    cloneHeader() {
        if (this.navFooter.length) return;
        let $header = $(".active.el-header").first();
        if (!$header.length) $header = $(".el-header").first();
        if (!$header.length) return;

        this.navFooter = $header.clone().appendTo(".row.nav");
        this.navFooter.attr("id", "nav-header").removeClass("active sticky").addClass("nav__footer");
        this.navContainer.removeClass("bg-white bg-black bg-blue").addClass(this.navFooter.data("bg-color"));
        const height = this.navFooter.outerHeight(true);
        $(".nav").css({transform: `translateY(-100%) translateY(${height}px)`, transition: "all 0"});
    }

    openNav() {
        this.cloneHeader();
        this.body.addClass("nav-open");
        this.menuToggle.attr("aria-expanded", true);
        this.navContainer.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", () => {
            $(".header").removeClass("shrink-it");
        });
    }

    closeNav() {
        this.menuToggle.attr("aria-expanded", false);
        this.body.removeClass("nav-open").addClass("js-nav-close-animation");
        if (this.body.hasClass("page--home")) $(".header").removeClass("page--home__nav-open");
        this.navContainer.one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", () => {
            this.body.removeClass("js-nav-close-animation");
            $(".nav__footer").remove();
        });
    }
}

function initializeFlipCardsOld() {
    $(".el-flip__entry").each(function () {
        const $entry = $(this);
        const $button = $entry.find("button");
        $button.on("click", () => {
            const $front = $entry.find(".el-flip__front");
            const $back = $entry.find(".el-flip__back");
            const color = $back.data("btn-color");
            const isFrontActive = $front.hasClass("active");
            $button.toggleClass(`close ${color}`, isFrontActive).attr("aria-pressed", isFrontActive);
            $front.toggleClass("active", !isFrontActive).toggleClass("inactive", isFrontActive);
            $back.toggleClass("active", isFrontActive).toggleClass("inactive", !isFrontActive);
        });
    });
}

function initializeFlipCards() {
    $(".el-flip__entry").each(function () {
        const $entry = $(this);
        const $button = $entry.find("button");
        const $front = $entry.find(".el-flip__front");
        const $back = $entry.find(".el-flip__back");

        const showBack = () => {
            const color = $back.data("btn-color");

            $button
                .addClass(`close ${color}`)
                .attr("aria-pressed", "true");

            $front
                .removeClass("active")
                .addClass("inactive");

            $back
                .removeClass("inactive")
                .addClass("active");
        };

        const showFront = () => {
            const color = $back.data("btn-color");

            $button
                .removeClass(`close ${color}`)
                .attr("aria-pressed", "false");

            $front
                .removeClass("inactive")
                .addClass("active");

            $back
                .removeClass("active")
                .addClass("inactive");
        };

        // Klick auf Button
        $button.on("click", (e) => {
            e.preventDefault();

            if ($front.hasClass("active")) {
                showBack();
            } else {
                showFront();
            }
        });

        // Hover über das komplette <li>
        $entry.on("mouseenter", () => {
            showBack();
        });

        $entry.on("mouseleave", () => {
            showFront();
        });
    });
}

export function initializeVideos() {
    $(".el-video").each(function () {
        const id = $(this).data("id");
        const $player = $(`#jquery_jplayer_${id}`);
        if (!$player.length || typeof $player.jPlayer !== "function") return;
        $player.jPlayer({
            ready() {
                $(this).jPlayer("setMedia", {
                    m4v: $player.data("video-file"),
                    poster: $player.data("video-img"),
                });
            },
            swfPath: "/resources/js/libs/jplayer/dist/jplayer",
            supplied: "webmv, ogv, m4v",
            cssSelectorAncestor: `#jp_container_${id}`,
            useStateClassSkin: true,
            autoBlur: false,
            smoothPlayBar: true,
            keyEnabled: true,
            remainingDuration: true,
            toggleDuration: true,
            optionsVideo: {size: {width: "100%", height: "100%"}},
        });
    });
    $("#jp_poster_0").attr("alt", "Bild für das Image Video");
}

function initializeDeferredMailchimpAssets() {
    const styles = Array.from(document.querySelectorAll(".js-deferred-mailchimp-style"));
    const scripts = Array.from(document.querySelectorAll(".js-deferred-mailchimp-script"));

    if (!styles.length && !scripts.length) return;

    const load = async () => {
        styles.forEach((template) => {
            const href = template.dataset.href;
            if (!href) return;

            const stylesheet = document.createElement("link");
            stylesheet.rel = "stylesheet";
            stylesheet.href = href;
            document.head.append(stylesheet);
            template.remove();
        });

        for (const template of scripts) {
            const script = document.createElement("script");
            const src = template.dataset.src;

            if (src) {
                script.src = src;
                script.async = false;
                await new Promise((resolve) => {
                    script.addEventListener("load", resolve, {once: true});
                    script.addEventListener("error", resolve, {once: true});
                    document.body.append(script);
                });
            } else {
                script.text = template.content.textContent;
                document.body.append(script);
            }

            template.remove();
        }
    };

    if (document.readyState === "complete") {
        load();
        return;
    }

    window.addEventListener("load", load, {once: true});
}

function initializePopUp() {
    const $popup = $("#popup");
    if (!$popup.length) return;

    const configuredDelay = Number.parseInt($popup.attr("data-popup-delay"), 10);
    const delay = Number.isFinite(configuredDelay) ? Math.max(0, configuredDelay) : 3000;

    const close = () => {
        $popup.removeClass("open").attr("aria-hidden", "true");
        $("body").removeClass("popup-open");
    };

    const open = () => {
        $popup.addClass("open").attr("aria-hidden", "false");
        $("body").addClass("popup-open");
        $popup.trigger("focus");
    };

    window.setTimeout(open, delay);

    $popup.on("click", (event) => {
        if (event.target === event.currentTarget) close();
    });

    $popup.find(".popup__link").on("click", () => close());

    $(document).on("keydown.popup", (event) => {
        if (event.key === "Escape" && $popup.hasClass("open")) close();
    });
}

export function initializeLegacySite() {
    if (window.__casinoFutureLegacyInitialised) return;
    window.__casinoFutureLegacyInitialised = true;

    const browser = new window.UAParser().getResult().browser;
    if (browser.name === "IE" && Number(browser.major) === 11) {
        $("html").addClass("isIE11 noclamp");
    } else {
        window.yall?.({observeChanges: true, events: {load: (event) => {
            const image = event.target;
            if (image.nodeName === "IMG" && !image.classList.contains("lazy")) image.classList.add("yall-loaded");
        }}});
    }

    $(function () {
        new ElementHeader();
        new Navigation($(".menu-toggle"));
        $("body").addClass("js-finished");
        if (!$("html").hasClass("isIE11")) {
            $(".el-h__title[data-animated='1']").each((_, element) => new Title(element));
        }
        initializeFlipCards();
        initializeDeferredMailchimpAssets();
        initializePopUp();
    });
}
